/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneChangelogRoute extends Route {
  @service declare intl: IntlService;

  analytics = {
    section: 'standalone',
    place: 'changelog',
  };

  get titleToken() {
    return this.intl.t('standalone.changelog.title');
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneChangelogRoute);
